module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24439/sass/messagesWidgetShell.sass"